// src/pages/WeeklyReports.js
import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { Icon } from '../icons';
import { COLORS, FONT_FAMILY, TYPOGRAPHY } from '../constants/color';

const WeeklyReports = () => {
  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
        <Icon name="file-bar-chart" sx={{ fontSize: 32, color: COLORS.PRIMARY }} />
        <Typography
          sx={{
            fontFamily: FONT_FAMILY,
            ...TYPOGRAPHY.H2,
            color: COLORS.TEXT,
          }}
        >
          Weekly Reports
        </Typography>
      </Box>
      
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Typography
          sx={{
            fontFamily: FONT_FAMILY,
            ...TYPOGRAPHY.BODY_STANDARD,
            color: COLORS.MUTED_TEXT,
          }}
        >
          Weekly reports view coming soon...
        </Typography>
      </Paper>
    </Box>
  );
};

export default WeeklyReports;